import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "action-buttons" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Accept")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Reject")

import HeadingComponent from './HeadingComponent.vue';
import TextComponent from './TextComponent.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    isLoading: { type: Boolean },
    onAccept: null,
    onReject: null
  },
  setup(__props: any) {

const props = __props as { isLoading: boolean; onAccept: () => void; onReject: () => void }



return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeadingComponent),
    _createVNode(TextComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseButton, {
          loading: __props.isLoading,
          onClick: props.onAccept
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_BaseButton, {
          loading: __props.isLoading,
          onClick: props.onReject
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}
}

})